import React from 'react';

function MovieDisplay({ movies }) {
  // Function to shuffle movies
  const shuffleMovies = (moviesArray) => {
    const moviesCopy = [...moviesArray];
    for (let i = moviesCopy.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [moviesCopy[i], moviesCopy[j]] = [moviesCopy[j], moviesCopy[i]];
    }
    return moviesCopy;
  };

  // Shuffle movies for display
  const shuffledMovies = shuffleMovies(movies);

  // Scroll to top when movies are displayed
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [movies]);

  return (
    <div id="movieDisplay">
      {shuffledMovies.map(movie => (
        <div key={movie.id} className="movie-info">
          <img 
            className="movie-poster" 
            src={`https://image.tmdb.org/t/p/w500${movie.poster_path}`} 
            alt={movie.title} 
            loading="lazy"
          />
          <div className="movie-details">
            <h2 className="movie-title">{movie.title}</h2>
            {movie.director && (
              <p className="movie-director-subtle">Directed by {movie.director}</p>
            )}
            <p className="movie-year">Release Date: {movie.release_date?.split('-')[0]}</p>
            <p className="movie-genre">Genre: {movie.genre_names}</p>
            <div className="rating-container">
              <p className="movie-rating">⭐ {movie.vote_average?.toFixed(1)}/10</p>
              <p className="vote-count">{movie.vote_count?.toLocaleString()} votes</p>
            </div>
            <p className="movie-plot">{movie.overview}</p>
            <a 
              href={`https://www.youtube.com/results?search_query=${encodeURIComponent(movie.title + ' ' + movie.release_date?.split('-')[0] + ' trailer')}`} 
              className="watch-btn" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              Watch Trailer
            </a>
          </div>
        </div>
      ))}
    </div>
  );
}

export default MovieDisplay;
